import React from 'react';
import { Row, Col, Typography } from 'antd';

const { Text, Title } = Typography;

export default function TotalSummary({ totalAll, totalPajak, otherAmount = 0 }) {
    const ppnRate = 11;
    const dpp = totalAll;
    const ppn = Math.round(totalPajak);
    const pph = 0; // PPh 23/4-2, user can adjust later
    const other = Number(otherAmount) || 0;
    const totalCharge = dpp + ppn - pph + other;

    const fmt = (val) => `Rp ${val.toLocaleString('id-ID')}`;

    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <div style={{
                    backgroundColor: '#FAFAFA',
                    padding: '20px 24px',
                    borderRadius: '8px',
                    border: '1px solid #e8e8e8',
                }}>
                    <Row justify="end" gutter={[0, 8]}>
                        <Col xs={24} md={12}>
                            <Row justify="space-between" style={{ marginBottom: 8 }}>
                                <Col><Text strong>DPP</Text></Col>
                                <Col><Text>{fmt(dpp)}</Text></Col>
                            </Row>
                            <Row justify="space-between" style={{ marginBottom: 8 }}>
                                <Col><Text strong>PPN ({ppnRate}.00%)</Text></Col>
                                <Col><Text>{fmt(ppn)}</Text></Col>
                            </Row>
                            <Row justify="space-between" style={{ marginBottom: 8 }}>
                                <Col><Text strong>PPh (23/4-2)</Text></Col>
                                <Col><Text>{fmt(pph)}</Text></Col>
                            </Row>
                            <Row justify="space-between" style={{ marginBottom: 8 }}>
                                <Col><Text strong>Biaya Lain-lain</Text></Col>
                                <Col><Text>{fmt(other)}</Text></Col>
                            </Row>
                            <div style={{ borderTop: '2px solid #cf1322', paddingTop: 8, marginTop: 4 }}>
                                <Row justify="space-between">
                                    <Col><Title level={5} style={{ margin: 0, color: '#cf1322' }}>TOTAL CHARGE</Title></Col>
                                    <Col><Title level={5} style={{ margin: 0, color: '#cf1322' }}>{fmt(totalCharge)}</Title></Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    );
}
